import React, { FC, useEffect } from 'react';

import { Global, css } from '@emotion/react';
import { formComplete, isBrowser } from '@lucid/utils';

interface FormCompleteProps {
  fieldZoominfoFormcompleteForm?: string;
  willAllowZoominfo?: boolean;
}

const FormComplete: FC<FormCompleteProps> = ({
  fieldZoominfoFormcompleteForm,
  willAllowZoominfo
}) => {
  useEffect(() => {
    if (isBrowser() && fieldZoominfoFormcompleteForm) {
      const firstName = document.querySelector('[name="FirstName"]');
      const email = document.querySelector('[name="Email"]');
      const firstNameParentNode = firstName?.parentNode;
      const emailParentNode = email?.parentNode;
      firstNameParentNode?.parentNode?.insertBefore(emailParentNode!, firstNameParentNode);
    }
  }, [fieldZoominfoFormcompleteForm]);

  if (fieldZoominfoFormcompleteForm && willAllowZoominfo) {
    formComplete(fieldZoominfoFormcompleteForm);

    return (
      <Global
        styles={css({
          'form[data-zi-mapped-form] input[data-zi-input-enriched="false"]': {
            display: 'block'
          },
          'form[data-zi-mapped-form] input[data-zi-input-enriched="true"]': {
            display: 'none',
            marginBottom: 0
          }
        })}
      />
    );
  }

  return null;
};

export default FormComplete;
